import type { ParentMessage } from '@servicetitan/web-chat-types';
import type { ExpandAvailabilityMessage } from './expandAvailability';

export function postMessageToChild(
  iframe: HTMLIFrameElement,
  targetOrigin: string,
  // SETO-7778: ExpandAvailabilityMessage is not in ParentMessage until types 1.3.0.
  message: ParentMessage | ExpandAvailabilityMessage,
): void {
  iframe.contentWindow?.postMessage(message, targetOrigin);
}
